import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';

export const loginEmailRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/email',
}).lazy(() => import('pages/shared/Login/VerifyEmail/VerifyEmail').then((d) => d.Route));
